<template>
  <div class="upload">
    <el-upload
      ref="upload-file"
      v-loading="loading"
      :show-file-list="true"
      :auto-upload="false"
      :multiple="false"
      :limit="1"
      :on-change="selectFile"
      action=""
      name="fileUpload"
      drag
    >
      <div class="upload-section d-flex justify-content-center align-items-center w-100 h-100">
        <b-icon-cloud-upload style="width: 64px; height: auto" />
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: {
    loading: Boolean
  },
  methods: {
    selectFile(file) {
      this.$emit('file', this.$refs['upload-file'].uploadFiles[0])
    }
  }
}
</script>

<style>
.el-upload, .el-upload-dragger {
  width: 100% !important;
}
</style>
